import React, { useEffect, useState } from 'react'
import { InputGroup, Form, Row, Col, Button, Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import assetService from '../../Services/assetService';
import { clearFilters, clearResults, setResults, setFulltext, addResults } from '../../Reducers/documentsReducer';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import "./Documents.css"
import Cart from '../../Components/Cart/Cart';
import DocumentsList from "../../Components/DocumentsList/DocumentsList"

const Documents = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [next, setNext] = useState();

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const filters = useSelector((state) => state.documents.filters);
    const results = useSelector((state) => state.documents.results);
    const channelGuid = useSelector((state) => state.channel.channelGuid);

    const navigate = useNavigate();

    useEffect(() => {
        dispatch(clearFilters());
        dispatch(clearResults());

        return () => {
            dispatch(clearResults());
            dispatch(clearFilters());
        }
    }, []);

    useEffect(() => {
        const fetchAssets = async () => {
            let body = {
                filters,
                "limit": 12
            };
            setIsLoading(true);

            if (channelGuid) {
                try {
                    const { status, data } = await assetService.getAssets(channelGuid, body);
                    if (status === 401) {
                        navigate("/access-denied");
                        return;
                    }
                    setNext(data?.next);
                    dispatch(setResults(data.items));
                } catch (error) {
                    console.error("Error retrieving documents: ", error);
                }
            }

            setIsLoading(false);
        };
        fetchAssets();
    }, [filters, channelGuid]);

    const handleSearch = (e) => {
        e.preventDefault();
        dispatch(setFulltext(searchTerm));
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch(e);
        }
    };

    const onClickMore = async () => {
        try {
            let body = {
                filters,
                "limit": 12,
                next
            }
            const { status, data } = await assetService.getAssets(channelGuid, body);
            if (status === 401) {
                navigate("/access-denied");
                return;
            }
            setNext(data.next);
            dispatch(addResults(data.items));
        } catch (error) {
            console.error("Error retrieving documents: ", error);
        }
    }

    return (
        <div className="container-fluid main-documents">
            <Container className='documents'>
                <Container className="form-container w-100 d-grid align-items-center">
                    <Form className="container form-section m">
                        <Row className="search-row">
                            <Col xs="12" md="9" className='h-100 searchbar'>
                                <Form.Label htmlFor="inlineFormInputGroup" visuallyHidden>
                                    Search
                                </Form.Label>
                                <InputGroup className="h-100">
                                    <InputGroup.Text><i className="bi bi-search"></i></InputGroup.Text>
                                    <Form.Control
                                        id="inlineFormInputGroup"
                                        placeholder={t('search')}
                                        value={searchTerm}
                                        aria-label="Search"
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onKeyDown={handleKeyPress} />
                                </InputGroup>
                            </Col>
                            <Col xs="12" md="3" className='h-100 mt-2 mt-md-0'>
                                <Button type="submit" className="h-100 w-100" onClick={(e) => handleSearch(e)}>
                                    {t('search')}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Container>
                <Container fluid className='p-0'>
                    <Cart />
                    <DocumentsList contents={results} isLoading={isLoading} getMoreAssets={onClickMore} next={next} />
                </Container>
            </Container>

        </div >
    )
}

export default Documents